<template>
    <nav class="eventwise-submenu tw-overflow-x-auto">
        <slot name="header"></slot>
        <a
            v-for="page in visiblePages"
            :key="JSON.stringify(page[valueKey])"
            href="#"
            :class="[
                {
                    active: modelValue === page[valueKey],
                },
                page.class,
            ]"
            @click.prevent="() => (modelValue = page[valueKey])"
        >
            <slot :page="page">
                <i
                    v-if="page.icon"
                    :class="[
                        modelValue === page[valueKey] && page.activeIcon ? page.activeIcon : page.icon,
                        modelValue === page[valueKey] && page.activeClass ? page.activeClass : null,
                    ]"
                ></i>
                {{ page.title ? page.title : page[valueKey] }}
            </slot>
        </a>
        <div v-if="$slots.footer" class="mt-auto"></div>
        <slot name="footer"></slot>
    </nav>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    pages: {
        type: Array,
        default() {
            return [];
        },
    },
    valueKey: {
        type: String,
        default: 'value',
    },
});
const modelValue = defineModel({
    type: [String, Number, Object],
    required: false,
});
const visiblePages = computed(() => {
    return props.pages.filter((p) => !p.hidden);
});
</script>

<style lang="scss" scoped>
@use '@/assets/sass/eventbooks/variables' as variables;

nav.eventwise-submenu {
    display: flex;
    scrollbar-width: thin;
    scrollbar-color: #d1d5db transparent;

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #d1d5db;
    }

    & > a,
    & > button {
        @apply tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2 tw-rounded-md tw-text-eventwise-700 tw-font-medium tw-transition-colors tw-whitespace-nowrap tw-duration-150;

        & > i {
            @apply tw-block tw-scale-125 tw-ml-0.5 tw-text-current tw-opacity-80;
        }

        &:hover {
            @apply tw-bg-gray-100 tw-text-eventwise-800;
        }

        &.active {
            @apply tw-bg-eventwise-400 tw-text-white;
        }

        &:not(:last-child) {
            margin-bottom: 5px;
        }
    }

    @media (max-width: 900px) {
        & > a {
            &:not(:last-child) {
                margin-bottom: unset;
                margin-right: 5px;
            }
        }
    }
}
</style>
